"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var closeIcon_1 = tslib_1.__importDefault(require("./closeIcon"));
var colors_1 = require("../colors");
var StyledCloseButton = styled_components_1.default.button(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n\tdisplay: flex;\n\tjustify-content: center;\n\theight: 32px;\n\twidth: 32px;\n\tborder-radius: 50%;\n\tborder: 1px solid ", ";\n\toutline: none;\n\tbackground-color: transparent;\n"], ["\n\tdisplay: flex;\n\tjustify-content: center;\n\theight: 32px;\n\twidth: 32px;\n\tborder-radius: 50%;\n\tborder: 1px solid ", ";\n\toutline: none;\n\tbackground-color: transparent;\n"])), colors_1.gray[1]);
function CloseButton(props) {
    return (react_1.default.createElement(StyledCloseButton, tslib_1.__assign({ className: "color-state gray1-text" }, props),
        react_1.default.createElement(closeIcon_1.default, null)));
}
exports.default = CloseButton;
var templateObject_1;
//# sourceMappingURL=index.js.map